<ng-container *ngIf="change.changeType === changeType.Unchanged">
    {{ change.originalValue | nullDash }}
</ng-container>
<ng-container *ngIf="change.changeType === changeType.Changed">
    <div class="value-panel">
        <span class="original-value">{{ change.originalValue | nullDash }}</span>
        <span class="new-value">{{ change.newValue | nullDash }}</span>
    </div>
</ng-container>
